/* eslint-disable camelcase, no-console */

export default {
  SET_EMBED_ENVIRONMENT(state, environment) {
    state.embedEnvironment = environment;
  },
  POPULATE_RESORT(state, resort) {
    state.activeMountainArea = resort.MountainAreas.filter(area => state.activeMountainAreaName == area.Name)[0];
    state.resort = resort;
    state.snow_report = resort.SnowReport;
    state.mountainAreas = resort.MountainAreas;
    state.trails = state.mountainAreas.map(area => area.Trails).flat();
    state.status = '';
    state.weatherPrimaryLayoutOption = resort.LayoutOptions.PrimaryWeather;
    state.weatherSecondaryLayoutOptions = resort.LayoutOptions.SecondaryWeather;
    state.legalDisclaimer = resort.LayoutOptions.Disclaimer;
    state.additionalText = resort.SnowReport.AdditionalText;
  },
  POPULATE_LIFTS(state, resort_lifts_feed) {
    state.lifts = resort_lifts_feed;
  },
  POPULATE_WEATHER(state, weather) {
    state.weather = weather;
    state.forecast = weather.Forecast;
    if (state.defaultWeatherZones.length === 3) {
      state.weatherZones = weather.CurrentConditions;
    } else {
      state.weatherZones = weather.CurrentConditions.filter(wz => state.defaultWeatherZones.indexOf(wz.Location) >= 0);
    }
    state.activeWeatherZone = weather.CurrentConditions.filter(wz => state.defaultWeatherZone === wz.Location)[0];
  },
  POPULATE_WEBCAMS(state, webcams) {
    state.webcams = webcams.WebCams;
  },
  POPULATE_SNOWFALL_DATA(state, snowfallData) {
    state.allSnowfallData = snowfallData.SnowfallEvents;
  },
  API_FAILURE(state, error) {
    console.error(error);
    state.status = 'Please refresh to try again. If this continues, please wait 5 minutes and try again.';
  },
  SET_ACTIVE_MOUNTAIN_AREA(state, mountainArea) {
    state.activeMountainArea = mountainArea;
  },
  SET_ACTIVE_MOUNTAIN_SECTION(state, mountainSection) {
    state.activeMountainSection = mountainSection;
  },
  SET_ACTIVE_WEATHER_ZONE(state, zone) {
    state.activeWeatherZone = state.weather.CurrentConditions.filter(wz => zone === wz.Location)[0];
  },
  SET_ACTIVE_DASHBOARD_SECTION(state, section) {
    state.activeDashboardSection = section;
  },
  SET_RESORT_TO_METRIC(state, metric) {
    state.defaultUnit = metric;
  },
  SET_SNOWBASE_UNIT(state, unit) {
    state.snowbaseUnit = unit;
  },
  SET_TEMPERATURE_UNIT(state, unit) {
    state.temperatureUnit = unit;
  },
  SET_WINDSPEED_UNIT(state, unit) {
    state.windspeedUnit = unit;
  },
  // True or false
  SET_SNOWFALL_SHOWN(state, setting) {
    state.snowfallChartSettings.showTotalSnowfall = setting;
  },
  // True or false
  SET_SNOWFALL_METRIC(state, setting) {
    state.snowfallChartSettings.snowfallInMetric = setting;
  },
  // monthly or annual
  SET_SNOWFALL_TIME_RANGE(state, setting) {
    state.snowfallChartSettings.snowfallTimeRange = setting;
  },
};
